import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { FaChevronDown } from 'react-icons/fa';
import Icon from '../Icon';
import styles from './FaqList.module.css';

export type Faq = { q: string; a: string };

type Props = {
  faqs: Faq[];
  /** Keeps panel ids unique if two lists ever share a page. */
  idPrefix?: string;
};

/** Question list as an accordion; the first answer starts open. */
const FaqList: React.FC<Props> = ({ faqs, idPrefix = 'faq' }) => {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <div className={styles.faqList}>
      {faqs.map(({ q, a }, i) => {
        const isOpen = open === i;
        const panelId = `${idPrefix}-${i}`;
        return (
          <div key={q} className={`${styles.faqItem} ${isOpen ? styles.faqOpen : ''}`}>
            <h3 className={styles.faqHeading}>
              <button
                type="button"
                className={styles.faqQuestion}
                aria-expanded={isOpen}
                aria-controls={panelId}
                onClick={() => setOpen(isOpen ? null : i)}
              >
                <span>{q}</span>
                <Icon icon={FaChevronDown} className={styles.faqChevron} aria-hidden />
              </button>
            </h3>
            <AnimatePresence initial={false}>
              {isOpen && (
                <motion.div
                  id={panelId}
                  key="panel"
                  initial={{ height: 0, opacity: 0 }}
                  animate={{ height: 'auto', opacity: 1 }}
                  exit={{ height: 0, opacity: 0 }}
                  transition={{ duration: 0.25, ease: 'easeOut' }}
                  className={styles.faqPanel}
                >
                  <p className={styles.faqAnswer}>{a}</p>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        );
      })}
    </div>
  );
};

export default FaqList;
